export const getCbpFullName = (
  cbpFormReferenceData,
  organization,
  modality,
  gender,
  sap,
  accepts290s,
  acceptsCCCMS,
  bPADedCap,
  lowIntensity,
  medIntensity,
  highIntensity,
  inactive
) => {
  let cbpFullName = '';
  const organizationsCbpName = cbpFormReferenceData?.organizations.filter(
    (item) => (item.orgId === organization ? item.orgKey : '')
  );
  const orgKey =
    organizationsCbpName?.[0]?.orgKey === undefined
      ? ''
      : organizationsCbpName?.[0]?.orgKey + '_';

  const modalityCbpName = cbpFormReferenceData?.modalities.filter((item) =>
    item.id === modality ? item.value : ''
  );
  const modalityId =
    modalityCbpName?.[0]?.id === undefined
      ? ''
      : modalityCbpName?.[0]?.id + '_';

  const genderCbpName = cbpFormReferenceData?.genders.filter((item) =>
    item.id === gender ? item.value : ''
  );
  const genderId =
    genderCbpName?.[0]?.id === undefined ? '' : genderCbpName?.[0]?.id + '_/';

  const sapCbpName = sap === true ? 'sap/' : '';
  const accept290CbpName = accepts290s === 1 ? '290/' : '';
  const acceptsCCCMSCbpName = acceptsCCCMS === 1 ? 'ccc/' : '';
  const bPADedCapCbpName = bPADedCap === true ? 'dc/' : '';
  const lowIntensityCbpName = lowIntensity === true ? 'LowTx/' : '';
  const medIntensityCbpName = medIntensity === true ? 'MedTx/' : '';
  const highIntensityCbpName = highIntensity === true ? 'HighTx/' : '';
  const inactiveCbpName = inactive === true ? ' (Inactive)' : '';

  return (cbpFullName =
    orgKey +
    modalityId +
    genderId +
    sapCbpName +
    accept290CbpName +
    acceptsCCCMSCbpName +
    bPADedCapCbpName +
    lowIntensityCbpName +
    medIntensityCbpName +
    highIntensityCbpName +
    inactiveCbpName);
};
